import comp from "./FocusTrapWrapper";
export default comp;
